<template>
<div class="unitCount">
  <div class="label">
    {{__('Quantity')}}
  </div>

  <div class="quantity">
    {{this.count}}
  </div>

  <div class="buttons">
    <div class="button increase"
      @click="increase"
      >

      <svg width="8px" height="6px" viewBox="0 0 8 6" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <g id="Light-Annika" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
              <g id="order" transform="translate(-452.000000, -404.000000)" stroke="#373737">
                  <g id="Group-2" transform="translate(204.000000, 386.000000)">
                      <g id="Group" transform="translate(248.000000, 19.000000)">
                          <polyline id="Path" points="0 3.61990246 3.86122929 2.13162821e-14 7.72245858 3.61990246"></polyline>
                      </g>
                  </g>
              </g>
          </g>
      </svg>
    </div>
    <div class="button decrease"
      @click="decrease"
      >
      <svg width="8px" height="6px" viewBox="0 0 8 6" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <g id="Light-Annika" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
              <g id="order" transform="translate(-452.000000, -414.000000)" stroke="#373737">
                  <g id="Group-2" transform="translate(204.000000, 386.000000)">
                      <g id="Group" transform="translate(248.000000, 19.000000)">
                          <polyline id="Path" transform="translate(3.861229, 11.809951) scale(1, -1) translate(-3.861229, -11.809951) " points="0 13.6199025 3.86122929 10 7.72245858 13.6199025"></polyline>
                      </g>
                  </g>
              </g>
          </g>
      </svg>
    </div>
  </div>
</div>
</template>
<script>

export default {
  props: {
    value: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      count: 1
    }
  },
  mounted () {
    this.count = this.value
  },
  watch: {
    value () {
      this.count = this.value
    }
  },
  methods: {
    increase () {
      this.count++

      this.$emit('input', this.count)
    },
    decrease () {
      this.count--

      if (this.count <= 1) {
        this.count = 1
      }

      this.$emit('input', this.count)
    }
  }
}

</script>
<style scoped lang="less">
  @import '~style/variables.less';

  .unitCount {
    position: relative;
    height: 50px;
    width: 100%;
    background-color: #ffffff;
    box-shadow: 0px 15px 35px rgba(0, 0, 0, 0.2);
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0px 20px;
    border-radius: 5px;
  }

  .label {
    font-weight: 700;
  }

  .quantity {
    display: flex;
    flex-grow: 1;
    align-items: flex-end;
    justify-content: flex-end;
    text-align: right;
    box-sizing: border-box;
    padding-right: 20px;
  }

  .buttons {
    height: 30px;
    width: 30px;
    box-sizing: border-box;
    display: relative;
    cursor: pointer;
  }

  .button {
    height: 50%;
    width: 100%;
    cursor: pointer;
    background-color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
